var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 3.95696L1.81802 18.017C1.64449 18.3177 1.5527 18.6585 1.55177 19.0057C1.55083 19.3529 1.64078 19.6943 1.81268 19.9959C1.98458 20.2975 2.23244 20.5489 2.53162 20.7251C2.83079 20.9012 3.17086 20.996 3.51802 21H20.363C20.7102 20.996 21.0502 20.9012 21.3494 20.7251C21.6486 20.5489 21.8965 20.2975 22.0684 19.9959C22.2403 19.6943 22.3302 19.3529 22.3293 19.0057C22.3283 18.6585 22.2365 18.3177 22.063 18.017L13.64 3.95696C13.4627 3.66495 13.2131 3.42355 12.9153 3.25602C12.6176 3.08849 12.2817 3.00049 11.94 3.00049C11.5984 3.00049 11.2625 3.08849 10.9647 3.25602C10.667 3.42355 10.4174 3.66495 10.24 3.95696Z",
    fill: "#66CC33",
    stroke: "#66CC33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleShape);
export default __webpack_public_path__ + "static/media/triangle-shape.23f93487b6d37cc925ecf234bb116791.svg";
export { ForwardRef as ReactComponent };